module.exports = __webpack_public_path__ + "img/about-phone.0e29f7b.png";